import React from "react"
import { compose, withPropsOnChange, mapProps } from "recompose"
import { getStatusById } from "../../api/entities/issue"
import withApiTransport from "../../api/apiTransport"
import styles from "./styles.css"

const Status = ({ name, color }) => (
  <div className={styles.container}>
    <span className={styles.status} style={{ backgroundColor: `#${color}` }} />
    <span style={{ color: `#${color}` }}>{name}</span>
  </div>
)

const enhance = compose(
  withPropsOnChange([`statusId`], ({ statusId }) => ({
    load: getStatusById,
    propName: `status`,
    payload: statusId,
  })),
  withApiTransport,
  mapProps(({ status: { color, name } = {} }) => ({ color, name })),
)

export default enhance(Status)
